import { forwardRef, ReactElement } from 'react';
import { IOrganismMenuItem } from '@belong/types';
import { Stack } from '@belong/ui-components';
import { removeTrailingSlash } from '@belong/url-utils';
import { ARIA_CURRENT, OFFCANVAS_LINK_PANEL_A11Y_ID } from '../../variables';
import { GHMobileLink } from '../GHMobileLink';
import { MobileLinkGroup } from './MobileLinkGroup';
import * as styles from './styles';

interface IMobileLinkPanel {
  linkPanelContent: IOrganismMenuItem | undefined;
  currentUrl: string | undefined;
  onLinkClick?: () => void;
}

export const MobileLinkPanel = forwardRef(
  ({ linkPanelContent, currentUrl, onLinkClick }: IMobileLinkPanel, ref: any): ReactElement => {
    return (
      <Stack space="large">
        <Stack space="xxsmall">
          <styles.LinkPanelHeading ref={ref} tabIndex={-1} id={OFFCANVAS_LINK_PANEL_A11Y_ID}>
            {linkPanelContent?.parentLabel}
          </styles.LinkPanelHeading>
          {linkPanelContent?.summaryLink && (
            <GHMobileLink
              aria-current={
                currentUrl === removeTrailingSlash(linkPanelContent.summaryLink.href) ? ARIA_CURRENT : undefined
              }
              href={linkPanelContent.summaryLink.href}
              iconName={linkPanelContent.summaryLink.navLinkIcon}
              label={linkPanelContent.summaryLink.label}
              onClick={onLinkClick}
              secondLevelLink
              iconRight={false}
            />
          )}
        </Stack>
        {linkPanelContent?.navGroup1?.map(navLinkGroup => (
          <MobileLinkGroup
            key={navLinkGroup.id}
            navLinkGroup={navLinkGroup}
            currentUrl={currentUrl}
            onLinkClick={onLinkClick}
          />
        ))}
        {linkPanelContent?.navGroup2?.map(navLinkGroup => (
          <MobileLinkGroup
            key={navLinkGroup.id}
            navLinkGroup={navLinkGroup}
            currentUrl={currentUrl}
            onLinkClick={onLinkClick}
          />
        ))}
      </Stack>
    );
  }
);

MobileLinkPanel.displayName = 'MobileLinkPanel';
